import i18n from "@/zapi-frontend/shared/i18n";

export const isRightNow = (date: Date) => {
  const now = new Date();
  const diff = now.getTime() - date.getTime();
  return diff < 1000 * 60 * 5;
};

// return date in a format like "May 15"
export const getMonthAndDay = (date: Date) => {
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};

export function formatRelativeTime(created: Date | string): string {
  const date = created instanceof Date ? created : new Date(created);
  const now = new Date();

  const diffMs = now.getTime() - date.getTime();
  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 1) return new Intl.DateTimeFormat("en-US").format(date); // 07/09/2025

  if (days === 1) return "1 day ago";

  if (hours >= 1) return `${hours} hour${hours === 1 ? "" : "s"} ago`;

  if (minutes >= 30) return "30 minutes ago";
  if (minutes >= 10) return "10 minutes ago";
  if (minutes >= 5) return "5 minutes ago";
  if (minutes >= 1) return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;

  return "just now";
}

export function formatTimeAgo(created: Date | string): string {
  const date = created instanceof Date ? created : new Date(created);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (seconds < 60) return i18n.t("common:timeAgo.justNow");

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return i18n.t("common:timeAgo.minutes", { count: minutes });

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return i18n.t("common:timeAgo.hours", { count: hours });

  const days = Math.floor(hours / 24);
  if (days < 7) return i18n.t("common:timeAgo.days", { count: days });

  const weeks = Math.floor(days / 7);
  if (weeks < 4) return i18n.t("common:timeAgo.weeks", { count: weeks });

  const months = Math.floor(days / 30);
  return i18n.t("common:timeAgo.months", { count: months });
}
